/**
 * @flow
 * @relayHash c1061c854355cf4570b84bc8c69c218c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddUpdateRunModal_job$ref = any;
type RunPanels_runEdges$ref = any;
export type RunStatus = "COMPLETE" | "IN_PROGRESS" | "PAUSED" | "SCHEDULED";
export type ScheduleJobInput = {|
  jobId: string,
  jobYieldIds?: ?$ReadOnlyArray<string>,
  stateRunOverrides?: ?$ReadOnlyArray<JobStateRunOverride>,
|};
export type JobStateRunOverride = {|
  jobStateId: string,
  machineId?: ?string,
  notes?: ?string,
|};
export type ScheduleJobMutationVariables = {|
  input: ScheduleJobInput
|};
export type ScheduleJobMutationResponse = {|
  +scheduleJob: {|
    +runEdges: $ReadOnlyArray<{|
      +cursor: string,
      +node: {|
        +id: string,
        +status: RunStatus,
        +scheduledStartAt: any,
        +scheduledEndAt: any,
        +notes: ?string,
        +jobState: {|
          +id: string,
          +workflowState: {|
            +id: string,
            +name: string,
          |},
        |},
        +machine: {|
          +id: string,
          +name: string,
          +type: {|
            +id: string,
            +name: string,
          |},
        |},
        +yields: {|
          +edges: ?$ReadOnlyArray<?{|
            +node: {|
              +id: string,
              +quantity: number,
              +item: {|
                +id: string,
                +name: string,
              |},
            |}
          |}>
        |},
        +job: {|
          +id: string,
          +importJobNumber: ?string,
          +jobNumber: string,
          +name: string,
          +runs: {|
            +edges: ?$ReadOnlyArray<?{|
              +$fragmentRefs: RunPanels_runEdges$ref
            |}>
          |},
          +states: $ReadOnlyArray<{|
            +id: string,
            +runs: $ReadOnlyArray<{|
              +id: string
            |}>,
          |}>,
          +$fragmentRefs: AddUpdateRunModal_job$ref,
        |},
      |},
    |}>
  |}
|};
export type ScheduleJobMutation = {|
  variables: ScheduleJobMutationVariables,
  response: ScheduleJobMutationResponse,
|};
*/


/*
mutation ScheduleJobMutation(
  $input: ScheduleJobInput!
) {
  scheduleJob(input: $input) {
    runEdges {
      cursor
      node {
        id
        status
        scheduledStartAt
        scheduledEndAt
        notes
        jobState {
          id
          workflowState {
            id
            name
          }
        }
        machine {
          id
          name
          type {
            id
            name
          }
        }
        yields {
          edges {
            node {
              id
              quantity
              item {
                id
                name
              }
            }
          }
        }
        job {
          id
          importJobNumber
          jobNumber
          name
          runs {
            edges {
              ...RunPanels_runEdges
              cursor
              node {
                __typename
                id
              }
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          states {
            id
            runs {
              id
            }
          }
          ...AddUpdateRunModal_job
        }
      }
    }
  }
}

fragment RunPanels_runEdges on RunEdge {
  node {
    id
    status
    scheduledStartAt
    jobState {
      id
      workflowState {
        id
        name
      }
    }
    machine {
      id
      name
    }
    yields {
      edges {
        ...RunYieldsList_runYieldEdges
        cursor
        node {
          __typename
          id
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    job {
      id
      ...AddUpdateRunModal_job
    }
    ...AddUpdateRunModal_run
    ...DeleteRunModal_run
    ...ViewRunModal_run
  }
}

fragment AddUpdateRunModal_job on Job {
  id
  states {
    id
    isEnabled
    workflowState {
      id
      name
      machineType {
        id
      }
    }
  }
  yields {
    edges {
      node {
        id
        item {
          id
          name
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment RunYieldsList_runYieldEdges on RunYieldEdge {
  totalItemQuantity
  node {
    id
    item {
      id
      name
      quantityUOM {
        id
        symbol
      }
    }
  }
}

fragment AddUpdateRunModal_run on Run {
  id
  scheduledStartAt
  notes
  machine {
    id
    name
    type {
      id
    }
  }
  jobState {
    id
  }
  yields {
    edges {
      node {
        id
        item {
          id
          name
        }
      }
    }
  }
}

fragment DeleteRunModal_run on Run {
  id
  machine {
    id
    name
    type {
      id
      name
    }
  }
}

fragment ViewRunModal_run on Run {
  id
  status
  notes
  scheduledStartAt
  scheduledEndAt
  actualStartAt
  actualEndAt
  jobState {
    id
    workflowState {
      id
      name
    }
  }
  machine {
    id
    name
    type {
      id
      name
    }
  }
  ...RunLogs_run
  ...RunYields_run
}

fragment RunLogs_run on Run {
  id
  yields {
    edges {
      setupQuantity
      runQuantity
      defectQuantity
      node {
        id
        item {
          id
          name
        }
      }
    }
  }
  machine {
    id
  }
  logs {
    id
    type
    notes
    createdAt
    user {
      ...UserWidget_user
      id
    }
  }
}

fragment RunYields_run on Run {
  id
  yields {
    edges {
      defectQuantity
      setupQuantity
      runQuantity
      node {
        id
        item {
          id
          name
          quantityUOM {
            id
            symbol
          }
        }
      }
    }
  }
}

fragment UserWidget_user on User {
  id
  firstName
  lastName
  ...UserAvatar_user
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ScheduleJobInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scheduledStartAt",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scheduledEndAt",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v9 = [
  (v3/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "jobState",
  "storageKey": null,
  "args": null,
  "concreteType": "JobState",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "workflowState",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkflowState",
      "plural": false,
      "selections": (v9/*: any*/)
    }
  ]
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "machine",
  "storageKey": null,
  "args": null,
  "concreteType": "Machine",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v8/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "type",
      "storageKey": null,
      "args": null,
      "concreteType": "MachineType",
      "plural": false,
      "selections": (v9/*: any*/)
    }
  ]
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "item",
  "storageKey": null,
  "args": null,
  "concreteType": "Item",
  "plural": false,
  "selections": (v9/*: any*/)
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "yields",
  "storageKey": null,
  "args": null,
  "concreteType": "RunYieldConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RunYieldEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "JobYield",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "quantity",
              "args": null,
              "storageKey": null
            },
            (v12/*: any*/)
          ]
        }
      ]
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "importJobNumber",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "jobNumber",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v18 = [
  (v3/*: any*/)
],
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "runs",
  "storageKey": null,
  "args": null,
  "concreteType": "Run",
  "plural": true,
  "selections": (v18/*: any*/)
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isEnabled",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "workflowState",
  "storageKey": null,
  "args": null,
  "concreteType": "WorkflowState",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v8/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "machineType",
      "storageKey": null,
      "args": null,
      "concreteType": "MachineType",
      "plural": false,
      "selections": (v18/*: any*/)
    }
  ]
},
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "yields",
  "storageKey": null,
  "args": null,
  "concreteType": "JobYieldConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "JobYieldEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "JobYield",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v12/*: any*/),
            (v16/*: any*/)
          ]
        },
        (v2/*: any*/)
      ]
    },
    (v17/*: any*/)
  ]
},
v23 = {
  "kind": "LinkedHandle",
  "alias": null,
  "name": "yields",
  "args": null,
  "handle": "connection",
  "key": "AddUpdateRunModal_job_yields",
  "filters": ([]/*: any*/)
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ScheduleJobMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "scheduleJob",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ScheduleJobPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "runEdges",
            "storageKey": null,
            "args": null,
            "concreteType": "RunEdge",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Run",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "job",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Job",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": "runs",
                        "name": "__Runs_job_runs_connection",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RunConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RunEdge",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Run",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/)
                                ]
                              },
                              {
                                "kind": "FragmentSpread",
                                "name": "RunPanels_runEdges",
                                "args": null
                              }
                            ]
                          },
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "states",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobState",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v19/*: any*/)
                        ]
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "AddUpdateRunModal_job",
                        "args": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ScheduleJobMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "scheduleJob",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ScheduleJobPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "runEdges",
            "storageKey": null,
            "args": null,
            "concreteType": "RunEdge",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Run",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "job",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Job",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "runs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "RunConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RunEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Run",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "yields",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "RunYieldConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "RunYieldEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalItemQuantity",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "JobYield",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "item",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Item",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  (v8/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "quantityUOM",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "UOM",
                                                    "plural": false,
                                                    "selections": [
                                                      (v3/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "symbol",
                                                        "args": null,
                                                        "storageKey": null
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v16/*: any*/)
                                            ]
                                          },
                                          (v2/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "setupQuantity",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "runQuantity",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "defectQuantity",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v17/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedHandle",
                                    "alias": null,
                                    "name": "yields",
                                    "args": null,
                                    "handle": "connection",
                                    "key": "Runs_job_yields",
                                    "filters": []
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "job",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Job",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "states",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "JobState",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v20/*: any*/),
                                          (v21/*: any*/)
                                        ]
                                      },
                                      (v22/*: any*/),
                                      (v23/*: any*/)
                                    ]
                                  },
                                  (v7/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "actualStartAt",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "actualEndAt",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "logs",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "RunLog",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "type",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v7/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "createdAt",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "user",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "firstName",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "lastName",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "avatar",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v16/*: any*/)
                                ]
                              },
                              (v2/*: any*/)
                            ]
                          },
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "runs",
                        "args": null,
                        "handle": "connection",
                        "key": "Runs_job_runs",
                        "filters": []
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "states",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobState",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ]
                      },
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "ScheduleJobMutation",
    "id": null,
    "text": "mutation ScheduleJobMutation(\n  $input: ScheduleJobInput!\n) {\n  scheduleJob(input: $input) {\n    runEdges {\n      cursor\n      node {\n        id\n        status\n        scheduledStartAt\n        scheduledEndAt\n        notes\n        jobState {\n          id\n          workflowState {\n            id\n            name\n          }\n        }\n        machine {\n          id\n          name\n          type {\n            id\n            name\n          }\n        }\n        yields {\n          edges {\n            node {\n              id\n              quantity\n              item {\n                id\n                name\n              }\n            }\n          }\n        }\n        job {\n          id\n          importJobNumber\n          jobNumber\n          name\n          runs {\n            edges {\n              ...RunPanels_runEdges\n              cursor\n              node {\n                __typename\n                id\n              }\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          states {\n            id\n            runs {\n              id\n            }\n          }\n          ...AddUpdateRunModal_job\n        }\n      }\n    }\n  }\n}\n\nfragment RunPanels_runEdges on RunEdge {\n  node {\n    id\n    status\n    scheduledStartAt\n    jobState {\n      id\n      workflowState {\n        id\n        name\n      }\n    }\n    machine {\n      id\n      name\n    }\n    yields {\n      edges {\n        ...RunYieldsList_runYieldEdges\n        cursor\n        node {\n          __typename\n          id\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    job {\n      id\n      ...AddUpdateRunModal_job\n    }\n    ...AddUpdateRunModal_run\n    ...DeleteRunModal_run\n    ...ViewRunModal_run\n  }\n}\n\nfragment AddUpdateRunModal_job on Job {\n  id\n  states {\n    id\n    isEnabled\n    workflowState {\n      id\n      name\n      machineType {\n        id\n      }\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RunYieldsList_runYieldEdges on RunYieldEdge {\n  totalItemQuantity\n  node {\n    id\n    item {\n      id\n      name\n      quantityUOM {\n        id\n        symbol\n      }\n    }\n  }\n}\n\nfragment AddUpdateRunModal_run on Run {\n  id\n  scheduledStartAt\n  notes\n  machine {\n    id\n    name\n    type {\n      id\n    }\n  }\n  jobState {\n    id\n  }\n  yields {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteRunModal_run on Run {\n  id\n  machine {\n    id\n    name\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment ViewRunModal_run on Run {\n  id\n  status\n  notes\n  scheduledStartAt\n  scheduledEndAt\n  actualStartAt\n  actualEndAt\n  jobState {\n    id\n    workflowState {\n      id\n      name\n    }\n  }\n  machine {\n    id\n    name\n    type {\n      id\n      name\n    }\n  }\n  ...RunLogs_run\n  ...RunYields_run\n}\n\nfragment RunLogs_run on Run {\n  id\n  yields {\n    edges {\n      setupQuantity\n      runQuantity\n      defectQuantity\n      node {\n        id\n        item {\n          id\n          name\n        }\n      }\n    }\n  }\n  machine {\n    id\n  }\n  logs {\n    id\n    type\n    notes\n    createdAt\n    user {\n      ...UserWidget_user\n      id\n    }\n  }\n}\n\nfragment RunYields_run on Run {\n  id\n  yields {\n    edges {\n      defectQuantity\n      setupQuantity\n      runQuantity\n      node {\n        id\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment UserWidget_user on User {\n  id\n  firstName\n  lastName\n  ...UserAvatar_user\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": null
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '66d47bbb8a8dbd89bac9b922e062a4b7';
module.exports = node;
